import React, { useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'

import namedEntityControlSetsService, {
  CreateNamedEntityControlSetRequest,
} from 'services/http/dataset/named-entity-control-set'

import { CreateNamedEntityControlSetProps } from './types'
import NamedEntityControlSetForm from './NamedEntityControlSetForm'

const CreateNamedEntityControlSet: React.FunctionComponent<CreateNamedEntityControlSetProps> =
  () => {
    const [isLoading, setIsLoading] = useState(false)
    const [flagcard] = useFlagcardContext()

    const handleSubmit = (
      values: CreateNamedEntityControlSetRequest,
      handleReset: () => void
    ) => {
      if (values) {
        setIsLoading(true)

        namedEntityControlSetsService
          .create(values)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'Kayıt işlemi başarılı',
              children:
                'Girmiş olduğunuz bilgiler ile birlikte veri sisteme başarıyla kayıt edilmiştir. Dilerseniz yeni veri ekleyebilirsiniz.',
            })

            handleReset()
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Bir hata oluştu',
              children:
                'Veri eklenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem
          text="Adlandırılmış varlık kontrol seti"
          href="/named-entity-control-set"
        />
        <BreadcrumbItem text="Adlandırılmış varlık kontrol seti oluştur" />
      </Breadcrumb>
    )

    return (
      <MainLayout>
        <Container width="medium">
          <Page>
            <PageHeader
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak yeni bir adlandırılmış varlık
                  kontrol seti oluşturabilirsiniz..
                </p>
              }
            >
              Adlandırılmış varlık kontrol seti oluştur
            </PageHeader>
            <NamedEntityControlSetForm
              actions={
                <Button
                  appearance="primary"
                  children="Adlandırılmış varlık kontrol seti oluştur"
                  isLoading={isLoading}
                  type="submit"
                />
              }
              operation="create"
              onError={handleError}
              onSubmit={handleSubmit}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default CreateNamedEntityControlSet
